module.exports = __webpack_public_path__ + "static/media/bg-04.a6f7e6ed.png";